import { render, staticRenderFns } from "./render_date.vue?vue&type=template&id=5d958106&scoped=true&"
import script from "./render_date.vue?vue&type=script&lang=js&"
export * from "./render_date.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d958106",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploy/cp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d958106')) {
      api.createRecord('5d958106', component.options)
    } else {
      api.reload('5d958106', component.options)
    }
    module.hot.accept("./render_date.vue?vue&type=template&id=5d958106&scoped=true&", function () {
      api.rerender('5d958106', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/packs/components/form/render_fields/render_date.vue"
export default component.exports